import { PublicClientApplication } from "@azure/msal-browser";
import EventManagementService from "../../services/events/eventmanagement.service";
import { APIHelper } from "../api/APIHelper";

export abstract class CrisisBoardHelper {
  public static async setCrisisboardPlanningTableKpi(
    msalInstance: PublicClientApplication,
    airportCode: string,
    resourceType: string,
    date: string,
    payload: any
  ): Promise<any> {
    const eventManagementService = new EventManagementService();

    const request = (msalInstance: string, payload: any) => {
      return eventManagementService.setCrisisboardPlanningKpi(
        msalInstance,
        airportCode,
        resourceType,
        date,
        payload
      );
    };

    return APIHelper.CallAPI(msalInstance, payload, request);
  }
}
